import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=be9a724c&scoped=true&"
import script from "./breadcrumb.vue?vue&type=script&lang=js&"
export * from "./breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9a724c",
  null
  
)

export default component.exports